import { render, staticRenderFns } from "./configApp.vue?vue&type=template&id=1c3ec210&scoped=true"
import script from "./configApp.vue?vue&type=script&lang=js"
export * from "./configApp.vue?vue&type=script&lang=js"
import style0 from "./configApp.vue?vue&type=style&index=0&id=1c3ec210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3ec210",
  null
  
)

export default component.exports